"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PriceBreakDownPropTypes = exports.PriceBreakDownDefaultPropTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var PriceBreakDownPropTypes = {
  firstNightKey: _propTypes.default.string,
  secondNightKey: _propTypes.default.string,
  TotalSavingsKey: _propTypes.default.string,
  firstNightValue: _propTypes.default.string,
  secondNightValue: _propTypes.default.string,
  TotalSavingsValue: _propTypes.default.string,
  totalAmount: _propTypes.default.string,
  totalPayableText: _propTypes.default.string,
  perRoomNight: _propTypes.default.string,
  summaryNightKey: _propTypes.default.string,
  savingLabel: _propTypes.default.string,
  notificationMessage: _propTypes.default.string,
  roomType: _propTypes.default.string,
  currency: _propTypes.default.string,
  strikethroughKey: _propTypes.default.string,
  RM9Val: _propTypes.default.string,
  theme: _propTypes.default.string
};
exports.PriceBreakDownPropTypes = PriceBreakDownPropTypes;
var PriceBreakDownDefaultPropTypes = {
  firstNightKey: '',
  secondNightKey: '',
  TotalSavingsKey: '',
  firstNightValue: '',
  secondNightValue: '',
  TotalSavingsValue: '',
  totalAmount: '',
  totalPayableText: '',
  perRoomNight: '',
  summaryNightKey: '',
  savingLabel: '',
  notificationMessage: '',
  roomType: '',
  currency: '',
  strikethroughKey: '',
  RM9Val: '',
  theme: ''
};
exports.PriceBreakDownDefaultPropTypes = PriceBreakDownDefaultPropTypes;